import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AttendanceContractCostSection } from '../../../-shared/AttendanceContractCostSection';
import { attendanceContractCostSearchSchema, type AttendanceContractCostSearch } from '../../../-shared/searchSchema';
export const Route = createFileRoute('/_staff/attendances/_layout/contract-and-cost/_contract-and-cost/payment/$period/')({
  component: AttendancePaymentOverviewPage,
  validateSearch: zodValidator(attendanceContractCostSearchSchema)
});
function AttendancePaymentOverviewPage() {
  const {
    period
  } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <AttendanceContractCostSection section="payment" period={period} search={search} onSearchUpdate={(next: Partial<AttendanceContractCostSearch>) => navigate({
    search: prev => ({
      ...prev,
      ...next
    }),
    replace: true
  })} />;
}